module.exports = __webpack_public_path__ + "img/photo-lifestyle-courier.f661cc05.jpg";